import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function getWorkspaceId() {
  let id = localStorage.getItem("cp_workspace_id");
  if (!id) {
    id = (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("cp_workspace_id", id);
  }
  return id;
}

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  config.headers["X-Workspace-Id"] = getWorkspaceId();
  return config;
});

export const WORKFLOW_STATUSES = {
  information_required: { label: "Information required", cls: "bg-amber-100 text-amber-900 border-amber-200" },
  client_confirmation_required: { label: "Client confirmation required", cls: "bg-orange-100 text-orange-900 border-orange-200" },
  legal_research_required: { label: "Consumer research required", cls: "bg-slate-100 text-slate-900 border-slate-300" },
  review_required: { label: "Review required", cls: "bg-blue-100 text-blue-900 border-blue-200" },
  lawyer_review_required: { label: "Review required", cls: "bg-blue-100 text-blue-900 border-blue-200" },
  approved_for_use: { label: "Approved for use", cls: "bg-green-100 text-green-900 border-green-200" },
};

export function evalCondition(cond, answers) {
  if (!cond) return true;
  const val = answers[cond.field];
  if (cond.op === "eq") return val === cond.value;
  if (cond.op === "ne") return val !== cond.value && val !== undefined;
  if (cond.op === "in") {
    if (Array.isArray(val)) return val.includes(cond.value);
    return val === cond.value;
  }
  return true;
}
